 

function SectionDivider() {

    return ( 
       <>
         <div class="section-divider"></div>
       </> 
 ); 

}

export default SectionDivider;